export default {
  titles: {
    encoding: 'Codificação',
    inbound: 'Recebimento',
    user_info: 'Informações do Usuário',
    settings: 'Configurações',
    reset_daily_items: 'Redefinir itens diários?',
    last_parcels: 'Últimos Pacotes',
    select_item: 'Selecionar Item',
    select_workstation: 'Selecionar estação de trabalho',
    select_language: 'Selecionar idioma',
    support: 'Suporte',
    select_printer: 'Selecionar impressora',
    shipment_to_confirm: 'Envio a Confirmar',
    sorting_details: 'Detalhes de ventilação',
    inventories: 'Inventários',
    pin_modal: 'Digite o PIN para forçar associação',
    shipments: 'Envios',
    report_problem: 'Reportar um problema',
    parcels: 'Pacotes',
    //moncler
    outbound_bthp: 'Certificado BTHP de Saída'
  },
  simple_parcel_list: {
    to_read: 'Para Ler',
    ok: 'Ok',
    force: 'Forçar',
    force_parcel: 'Forçar pacote {{code}}',
    force_parcel_desc: 'Digite o PIN do usuário para forçar o pacote',
    forced: 'Forçado',
    unexpected: 'Inesperado',
    remove: 'Remover',
    invalid_pin: 'PIN do usuário inválido',
    loading: 'Carregando lista de pacotes'
  },
  create_parcel_gate: {
    //moncler
    width: 'Largura',
    height: 'Altura',
    depth: 'Profundidade',
    tare: 'Tara',
    description: 'Descrição'
  },
  fields: {
    current_location: 'Localização Atual',
    identified_item: 'Item Identificado',
    ignored_items: 'Itens Ignorados',
    ignored_with_reason_items: 'Itens ignorados com motivo',
    error_items: 'Itens com Erro',
    warning_items: 'Itens com Aviso',
    umg: 'Umg',
    custom_class: 'Classe personalizada',
    product_code: 'Código de produto',
    as400username: 'Nome de usuário AS400',
    item_components: 'Componentes',
    //valentino
    mission: 'Missão',
    mission_type: 'Tipo de missão',
    supplier: 'Fornecedor',
    physical_storage: 'Armazenamento físico',
    season: 'Temporada',
    ddt: 'DDT',
    notification: 'Notificação',
    ddt_date: 'Data DDT',
    notification_date: 'Data de Notificação',
    product_category: 'Categoria de produto',
    status: 'Status',
    date: 'Data',
    creation_date: 'Data de Criação',
    sender: 'Remetente',
    year: 'Ano',
    number: 'Número',
    row: 'Linha',
    entity: 'Entidade',
    labels: 'Etiquetas'
  },
  misc: {
    select_an_option: 'Selecionar uma opção...',
    not_set: 'Não definido',
    current_value: 'Valor atual',
    pleaseWait: 'Por favor, aguarde...',
    not_associated: 'Não associado',
    replaced: 'Substituído',
    production_order_info: 'Info Ordem de Produção',
    reel_info: 'Info Bobina',
    reel_code: 'Código Bobina',
    assigned_supplier: 'Fornecedor Atribuído',
    type: 'Tipo',
    identifier_info: 'Info Identificador',
    identifier_events: 'Eventos do Identificador',
    or: 'ou',
    select_place: `Olá {{user}}, selecione seus locais de origem para continuar`,
    back: 'Voltar',
    refresh: 'Atualizar',
    reload: 'Recarregar',
    save: 'Salvar',
    confirm: 'Confirmar',
    confirm_auto: 'Confirmação automática',
    update_and_confirm: 'Atualizar e confirmar',
    update: 'Atualizar',
    no_carton_found: 'Nenhuma caixa encontrada',
    confirm_continue: 'Confirmar e continuar',
    cancel: 'Cancelar',
    close: 'Fechar',
    user: 'Usuário',
    workstation: 'Estação de trabalho',
    username: 'Nome de usuário',
    name: 'Nome',
    password: 'Senha',
    login: 'Entrar',
    encoding: 'Codificação',
    code: 'Código',
    ean_code: 'Código EAN',
    certilogo: 'Certilogo',
    enter_the_necessary_fields: 'Preencha os campos necessários para iniciar a operação',
    associated_items: 'Itens Associados',
    associate: 'Associar',
    associated: 'Associado',
    verify: 'Verificar',
    verify_association: 'Verificar',
    reading: 'Leitura',
    processing: 'Processando',
    association: 'Associação',
    associations: 'Associações',
    waiting: 'Aguardando',
    writing: 'Escrevendo',
    writing_progress: 'Escrita em andamento...',
    partial_confirm: 'Confirmação Parcial',
    retry: 'Tentar novamente',
    writing_association: 'Escrita e associação',
    confirmed: 'Confirmado',
    unable_to_write: `Impossível escrever tag epc : {{code}} para o produto: {{productCode}}`,
    unable_to_get_next_epc: `Impossível obter o próximo epc para: {{productCode}}`,
    unable_to_connect_to_workstation: 'Impossível conectar à estação de trabalho',
    tag_info: 'Info Tag',
    inbound: 'Recebimento',
    outbound: 'Expedição',
    stop: 'Parar',
    start: 'Iniciar',
    pause: 'Pausar',
    clear: 'Limpar',
    tag_encoded_today: 'Tag codificada hoje',
    transaction_date: 'Data de transação',
    select_transaction_date: 'Selecionar data de transação',
    ready_to_receive: 'Pronto para receber',
    change_password: 'Alterar Senha',
    logout: 'Sair',
    are_you_sure_to_logout: 'Você realmente quer sair?',
    settings: 'Configurações',
    roles: 'Funções',
    role: 'Função',
    email: 'E-mail',
    place: 'Local',
    items: 'Itens',
    description: 'Descrição',
    color: 'Cor',
    size: 'Tamanho',
    part: 'Parte',
    total_reads: 'TOTAL DE LEITURAS',
    total_ok: 'TOTAL OK',
    save_to_list: 'Salvar na lista',
    destination: 'Destino',
    origin: 'Origem',
    new_parcel: 'Novo Pacote',
    status: 'Status',
    parcel: 'Pacote',
    read_parcel: 'Ler Pacote',
    parcels: 'Pacotes',
    shipment: 'Envio',
    creation_date: 'Data de Criação',
    search: 'Pesquisar',
    select_search: 'Pesquisar...',
    detail: 'Detalhe',
    quantity: 'Quantidade ({{quantity}})',
    only_quantity: 'Quantidade',
    style: 'Estilo',
    material: 'Material',
    shipment_code_auto: 'Código de envio (automático)',
    parcel_code_auto: 'Código de pacote (automático)',
    next: 'Próximo',
    parcels_to_receive: 'Pacotes a receber',
    confirm_parcel: 'Confirmar Pacote',
    image_missing: 'IMAGEM AUSENTE',
    image: 'Imagem',
    loading: 'Carregando...',
    unknown_product: 'Produto Desconhecido',
    unknown_tag: 'Tag Desconhecida',
    invalid_tag: 'Tag Inválida',
    virgin_tag: 'Tag Virgem',
    tag_not_associated: 'Tag não associada',
    killed: 'Excluída',
    stock: 'Estoque',
    valid: 'Válido',
    unknown: 'Desconhecido',
    actions: 'Ações',
    reprint: 'Reimprimir',
    product: 'Produto',
    product_items: 'Itens do Produto',
    identifiers: 'Identificadores',
    zone: 'Zona',
    location: 'Localização',
    report_repair: 'Reportar Reparo',
    reason: 'Motivo',
    request_code_change: 'Solicitar Alteração de Código',
    enable_workstation_emulation: 'Ativar emulação de estação de trabalho',
    enable_browser_print_emulation: 'Ativar emulação de impressão de navegador',
    filter: 'Filtro',
    language: 'Idioma',
    warning: 'Aviso',
    success: 'Sucesso',
    info: 'Info',
    checklist: 'Lista de verificação',
    optional: 'Opcional',
    phone: 'Telefone',
    version: 'Versão',
    printer: 'Impressora',
    new_shipment: 'Novo Envio',
    upc: 'UPC',
    model_part_color_size: 'Modelo / Parte / Cor / Tamanho',
    confirm_shipment: 'Confirmar Envio',
    receive: 'Receber',
    delete: 'Excluir',
    delete_association: 'Excluir',
    change: 'Alterar',
    from: 'De',
    to: 'Para',
    ignored: 'Ignorado',
    skipped: 'Ignorado',
    ignored_with_reason: 'Ignorado com motivo',
    yes: 'Sim',
    no: 'Não',
    model: 'Modelo',
    typology: 'Tipo',
    no_result: 'Sem resultado',
    expected: 'Esperado',
    expected_plural: 'Esperados',
    read: 'Lido',
    missing: 'Ausente',
    unexpected: 'Inesperado',
    unexpected_parcel: 'Pacote inesperado',
    ignored_plural: 'Ignorados',
    serial: 'Série',
    priority: 'Prioridade',
    group: 'Grupo',
    required_quantity: 'Qtd necessária',
    sorted_quantity: 'Qtd ventilada',
    missing_quantity: 'Qtd ausente',
    barcode: 'Código de barras',
    barcode_bc: 'Código de barras BC',
    sorted_date: 'Data de ventilação',
    customer: 'Nome do cliente',
    list: 'Lista',
    list_position: 'Posição na Lista',
    select_date: 'Selecionar data',
    item_info: 'Info do item',
    item_identifier_info: 'Info do identificador do item',
    item_identifier_events: 'Eventos do identificador do item',
    item_events: 'Eventos do item',
    operation_type: 'Tipo de operação',
    operation_place: 'Local da operação',
    loading_data: 'Por favor, aguarde, os dados estão carregando ...',
    empty_item_events: 'Nenhum evento encontrado',
    show_more: 'Mostrar mais',
    hide_more: 'Ocultar mais',
    production_order: 'Ordem de Produção',
    production_order_detail: 'Detalhe da Ordem de Produção',
    production_order_row: 'Linha da Ordem de Produção',
    production_order_sku: 'SKU da Ordem de Produção',
    kill_tag: 'Excluir Tag',
    replace_tag: 'Substituir Tag',
    replace_tag_with: 'Substituir tag por {{tag}}',
    item_po: 'Ordem principal do item',
    item_order: 'Ordem do Item',
    item_row: 'Linha do Item',
    pack_code: 'Código de Embalagem',
    send_reads: 'Enviar Leituras',
    items_add_inventory_success: 'Itens adicionados ao inventário',
    new: 'Novo',
    confirm_mission: 'Confirmar missão',
    confirm_mission_text: 'Tem certeza que quer confirmar a missão?',
    parziali: 'Parcial',
    total_quantity: 'Quantidade total',
    accepted_quantity: 'Quantidade aceita',
    country_check: 'Controle de país',
    showcase_check: 'Controle de vitrine',
    attention: 'Atenção',
    clear_items: 'Ao prosseguir, todas as leituras serão removidas. Deseja continuar?',
    add_partial: 'Atenção',
    add_partial_text: 'Pode ser necessário criar uma Missão de Controle de Qualidade',
    add_partial_already_text:
      'Pode ser necessário criar uma Missão de Controle de Qualidade. UMG já trabalhada. Deseja substituir os itens lidos?',
    error_cq_mission: 'Atenção, criar Missão para Controle de Qualidade',
    warning_zone_items: 'EM_OUTRA_ZONA',
    internal_tag: 'Tag Interna',
    external_tag: 'Tag Externa',
    error_tag: 'Tag com erro',
    awaiting: 'Aguardando',
    error_logs: 'Registros de erros',
    event_logs: 'Registros de eventos',
    box_closed: 'Caixa fechada',
    box_out: 'Caixa fora',
    unexpected_list: 'Lista de itens inesperados',
    pending_tags: 'Tags pendentes',
    selected_zone: 'Zona selecionada',
    pricing: 'Preços',
    send_to_sap: 'Enviar para SAP',
    write_tag: 'Escrever Tag',
    identifier_tag: 'Tag Identificadora',
    digit_identifier_tag: 'Digite a tag a escrever',
    target_epc: 'EPC de destino',
    retry_write_tag: 'Foi encontrado um erro de escrita. Deseja tentar escrever a tag novamente?',
    ready: 'Pronto',
    offline: 'Sem conexão',
    shipping_date: 'Data de Envio',
    update_only_product: 'Item já associado a outro produto. Tem certeza que quer substituir?',
    update_production_order_row:
      'Item já associado a outra linha de Ordem de Produção. Tem certeza que quer substituir?',
    export: 'Exportar',
    select_zone: 'Selecionar zona',
    location_origin: 'Localização de origem',
    confirm_kill_tag: 'Quais tags você deseja excluir?',
    kill_in_progress: 'Exclusão de tags em andamento',
    confirm_replace_tag: 'Quais tags você deseja substituir?',
    replace_in_progress: 'Substituição de tags em andamento',
    select_tag_to_kill: 'Selecione a tag que deseja excluir',
    disassociating_item: 'Desassociando item',
    killing_tag: 'Excluindo tag {{type}} com função {{role}}',
    retry_kill_tag: 'Foi encontrado um erro de exclusão. Deseja tentar excluir a tag novamente?',
    reading_tag: 'Lendo Tag',
    writing_tag: 'Escrevendo Tag',
    writing_tag_with: 'Escrevendo tag {{tag}}',
    navBackWarning: 'Tem certeza que quer voltar? Todas as alterações não salvas, como leituras, serão perdidas.',
    sentry: {
      report_problem: 'Descreva o problema encontrado ou sugira uma melhoria'
    },
    ready_to_read: 'Pronto para ler',
    remove_product_readings: 'Remover leituras do produto',
    ok: 'OK',
    already_in_parcel: 'já no pacote',
    operation_canceled_by_user: 'Operação cancelada pelo usuário',
    load_more: 'carregamento em andamento',
    input: 'Entrada',
    rfid_barcodes: 'Códigos de barras RFID',
    submit: 'Enviar',
    //valentino
    error: 'Erro',
    OK_WORKER: 'OK TRABALHADOR',
    KO_WORKER: 'KO TRABALHADOR',
    OK_REPAIR: 'OK REPARO',
    RESO_RICHIESTO_CQ: 'CQ SOLICITADO',
    RESO_OK: 'OK DEVOLUÇÃO',
    OK_VALDAGNO: 'OK VALDAGNO',
    KO_VALDAGNO: 'KO VALDAGNO',
    SECOND_VALDAGNO: 'SEGUNDA ESCOLHA',
    OK_LINING: 'OK FORRO',
    ok_first_inbound_status: 'OK PRIMEIRO RECEBIMENTO',
    OK_RISC: 'RISCO',
    KO_LINING: 'KO FORRO',
    size_color: 'Tamanho/Cor',
    select_size_color: 'Selecionar tamanho/cor',
    print: 'Imprimir',
    missings: 'Ausentes',
    embedded: 'Embutido',
    ignoreds: 'Ignorados',
    select_printer: 'Selecionar impressora',
    printing_started: 'Impressão iniciada',
    release_reports: 'Relatórios de lançamento',
    quality_checks: 'Controles de qualidade',
    quality_check: 'Controle de qualidade',
    total_mission_qty: 'Qtd total da missão',
    inbound_read_qty: 'Qtd lida na entrada',
    checked_qty: 'Qtd verificada',
    checked: 'Verificados',
    returned: 'Devolvidos',
    damaged: 'Danificados',
    qty_damaged_first_check: 'Qtd danificados 1.ª verificação',
    first_check_date: 'Data 1.ª verificação',
    qty_damaged_second_check: 'Qtd danificados 2.ª verificação',
    second_check_date: 'Data 2.ª verificação',
    note: 'Nota',
    work_order: 'Ordem de Trabalho',
    order_type: 'Tipo de ordem',
    //louis vuitton
    start_and_read: 'Por favor, inicie as antenas e coloque o produto',
    emulate: 'Emular',
    advanced_emulation: 'Emulação Avançada',
    emulation_history: 'Histórico de Emulação',
    emulation_favorites: 'Favoritos',
    power: 'Potência',
    sensitivity: 'Sensibilidade',
    expected_quantity: 'Esperado',
    extra_quantity: 'Extra',
    encoded_quantity: 'Codificado',
    clear_and_restart: 'Limpar e Reiniciar',
    all: 'Todos',
    today: 'Hoje',
    lastweek: 'Semana passada',
    specific: 'Específico',
    apply: 'Aplicar',
    products: 'Produtos',
    last_paired_sn: 'Último SN emparelhado',
    last_confirmed_ucs: 'Último UCS confirmado',
    user_manual: 'Manual do usuário',
    operation_user_manual: 'Manual do usuário da operação',
    activity: 'Atividade',
    encodings: 'Codificações',
    progress: 'Progresso',
    encoding_user: 'Usuário de codificação',
    encoding_place: 'Local de codificação'
  },
  error: {
    error: 'Erro',
    errors: 'Erros',
    forbidden: 'Proibido',
    not_found: 'Não encontrado',
    product_not_found: 'Produto Não Encontrado',
    unauthorized: 'Não autorizado',
    too_many_tags_read: 'Tags lidas em excesso (esperado {{exptected}} lido {{read}})',
    too_many_checklist_types:
      'Muitos tipos de lista de verificação. Certifique-se de selecionar pacotes com o mesmo tipo de lista de verificação.',
    rfid_discrepancies_found:
      'Discrepâncias RFID encontradas, limpe tudo e tente novamente ou confirme com discrepâncias',
    certilogo_not_found: 'Certilogo "{{code}}" não encontrado',
    ean_not_found: 'EAN "{{code}}" não encontrado',
    production_order_not_found: 'Ordem de Produção "{{code}}" não encontrada',
    no_inbound_zones: 'Sem zonas de recebimento',
    no_operation_config: 'Configuração de operação não encontrada',
    not_supported_reading_mode: 'Modo de leitura não suportado',
    undefined_operation_config: 'A configuração da operação não pode ser indefinida',
    certilogo_already_encoded: 'Certilogo "{{code}}" já codificado',
    tag_not_found: 'Tag não encontrada',
    missing_printer_id: 'IP de impressora ausente',
    tag_unassociated: 'Tag não associada',
    tag_type_unexpected: 'Tipo de tag inesperado',
    tag_already_associated: 'Tag já associada. Você deve desassociá-la primeiro',
    tags_not_associated: 'Uma ou mais tags não estão associadas',
    tags_mismatch: 'Incompatibilidade de tags',
    workstation_could_not_be_started: 'Estação de trabalho {{code}} não pôde ser iniciada',
    antenna_was_started: 'Antena {{code}} foi iniciada',
    antenna_was_not_started: 'Antena {{code}} não foi iniciada',
    authentication_failed: 'Autenticação falhou',
    field_required: 'O campo {{label}} é obrigatório',
    unable_to_connect_to_rfid_reader:
      'Impossível conectar ao leitor RFID. Verifique se o dispositivo está ligado.',
    items_in_error_found: 'Itens com erro encontrados',
    item_not_in_inbound: 'Item não está em recebimento',
    item_not_in_stock: 'Item não está em estoque',
    item_in_another_parcel: 'Item em outro pacote',
    item_in_another_production_order: 'Item em outra ordem de produção',
    connection: 'Erro de conexão',
    connection_details:
      'Não houve resposta do servidor. Verifique se sua conexão com a internet ou configuração de VPN estão funcionando.',
    field_invalid_default: 'Valor padrão inválido "{{defaultValue}}" para o campo {{field}}',
    field_invalid: 'Valor inválido para o campo {{field}}',
    field_invalid_default_from_endpoint: 'Não foi possível encontrar um valor para o campo {{field}}',
    sorting_already_read: 'Item com série {{serial}} já lido no grupo {{group}}',
    sorting_no_group: 'Item não pode ser ventilado',
    sorting_not_in_zone: 'Item com série {{serial}} não pode ser ventilado. Já na zona {{zone}}',
    sorting_unknown: 'A tag {{tag}} não é válida',
    sorting_unexpected: 'Tag inesperada',
    no_item_configuration: 'Nenhuma configuração de item encontrada',
    item_creation_error: 'Erro na criação do item',
    couldn_find_production_order: 'Não foi possível encontrar a ordem de produção',
    couldn_find_production_order_row: 'Não foi possível encontrar a linha de ordem de produção',
    missing_operation_option: 'Opção de operação ausente: {{error}}',
    item_session_list_create: 'Lista não criada',
    item_session_list_create_session: 'Lista de sessão não criada',
    item_session_list_confirm: 'Lista não confirmada',
    item_session_list_confirm_session: 'Lista de sessão não confirmada',
    form_validation: 'Validação do formulário',
    form_validation_message: 'Erro ao preencher o campo',
    select_place_error: 'Não foi possível salvar o local de origem',
    self_user_data: 'Não foi possível salvar seus dados',
    encoding_no_tags: 'Nenhuma tag adicional foi lida. Operação cancelada',
    timeout_no_reads:
      'Nenhuma tag/ordem de produção detectada. Aproxime o produto da antena e reinicie',
    only_virgin_tag: 'Apenas tags virgens detectadas',
    tags_mismatch_error: 'Por favor, leia uma tag de cada vez',
    tags_mismatch_workorder: 'Discrepância de linha workorder',
    tags_errors: 'Erros de tag',
    value_not_valid: 'O valor inserido não é válido',
    write_tag: 'Erro desconhecido durante a escrita da Tag',
    WRONG_PRODUCTION_ORDER: 'Ordem de Produção Errada',
    WRONG_PLACE: 'Local errado',
    PRODUCTION_ORDER_ROW_CREATION_ERROR: 'Erro na criação da linha de ordem de produção',
    force_tag_associated: 'Tag já associada. Reassociar?',
    operation_confirm_error: 'Erro ao confirmar a operação',
    missing_mandatory_qc: 'Sem controle de qualidade. Continuar?',
    wrong_qc_status: 'O produto foi declarado KO. Continuar?',
    wrong_qc_size: 'Verificar tamanho. Continuar?',
    wrong_qc_size_payload:
      'Verificar tamanho. Tamanho de codificação: {{productSize}} - Tamanho físico: {{manualSize}}. Continuar?',
    wrong_qc_model: 'Verificar modelo. Continuar?',
    start_checklist: 'Lista de verificação não iniciada',
    confirm_with_unexpected: 'Não é possível confirmar com tags inesperadas',
    confirm_with_overqty: 'Não é possível confirmar com tags em excesso de quantidade',
    rfid_reader_initialization: 'Erro desconhecido durante a inicialização do leitor RFID',
    remove_sap_item_error: 'Impossível remover item',
    no_asn_selected: 'Nenhum ASN selecionado',
    submit_asn: 'Erro ao enviar ASN',
    zbpNotFound:
      'Agente Zebra Browser Print não encontrado no seu sistema. Certifique-se de que está instalado e em execução',
    no_printer_selected: 'Nenhuma impressora selecionada',
    zplTemplateNotDefined:
      "Modelo ZPL não definido. Defina um código de modelo no atributo 'zpl-template-code' da configuração de operação",
    no_print_template: 'Modelo de impressão não encontrado',
    wrong_tag: 'Tag Errada',
    tag_error_or_not_authentic: 'Tag não autêntica ou erro de autenticação',
    authentication_timeout: 'Tempo limite de autenticação',
    tid_missing: 'Tid para tag lida está ausente',
    on_destination: 'no destino {{destination}}',
    item_not_sortable: 'Item com série {{serial}} não pode ser ventilado',
    search_error: 'Erro de pesquisa',
    no_parcel_found_by_identifier: 'Nenhum pacote encontrado com estes identificadores',
    kill_tag_not_allowed:
      'Não é possível excluir uma tag associada a um item. Para excluir a tag, primeiro desassocie o item.',
    kill_already_killed: 'Tag já excluída',
    can_kill_only_tag_type: 'Você só pode excluir tags do tipo {{type}}',
    replace_tag_not_allowed: 'Você só pode substituir tags associadas a um item',
    kill_tag_not_success: 'Exclusão de tag falhou',
    replace_tag_not_success: 'Substituição de tag falhou',
    nfc_tag_not_expected: 'Tag NFC não esperada para este produto',
    ventilation_quantity_reached: 'A quantidade a ser ventilada para este produto já foi atingida',
    confirm_not_allowed_with_errors: 'Confirmação não permitida com erros',
    close_not_allowed_with_errors: 'Fechamento não permitido com erros',
    generic: 'Ocorreu um erro ao enviar o feedback',
    form_entry: 'Alguns campos são obrigatórios',
    invalid_tag_read: 'Leitura de tag inválida',
    read_one_tag_time: 'Leia apenas uma tag de cada vez',
    validation_failed_rewrite: 'Validação falhou para configuração de reescrita',
    uhf_tag_not_found: 'Tag UHF não encontrada',
    compute_tags_failed: 'Falha na geração da tag a escrever',
    be_generic_error: 'Erro de sistema',
    be_generic_error_description: 'Ocorreu um erro genérico no sistema.',
    identifier_production_order_not_found: 'Ordem de produção não encontrada',
    gs1code_invalid: 'Código GS1 não válido',
    productionorderrow_mismatch: 'Incompatibilidade de linha de ordem de produção. Continuar mesmo assim?',
    //cucinelli
    nfc_already_associated: 'NFC já associado. Desassocie e repita a operação',
    too_many_valid_tag_read: 'Muitas tags válidas lidas',
    fields_required: ' é obrigatório',
    exceeded_quantity: 'Quantidade excedida',
    production_order_completed: 'Ordem de produção está concluída',
    production_order_row_completed: 'Linha de ordem de produção está concluída',
    replace_tag_not_allowed_for_this_tag: 'Não é possível substituir este tipo de tag',
    box_already_received: 'Caixa já recebida. Ignorar leitura.',
    MISSING_EAN_ATTRIBUTE: 'EAN não encontrado para o produto {{productCode}}',
    other_production_order: 'Já associado a uma ordem de produção e produto diferentes',
    workorder_mismatch:
      "SKU do PRODUTO não corresponde ao indicado na embalagem - Verifique se o PRODUTO na embalagem está correto e prossiga com a associação"
  },
  messages: {
    no_operations_found: 'Nenhuma operação encontrada. Verifique as permissões do usuário no Painel de Controle',
    not_allowed_operation: `Você não tem permissão para realizar esta operação. Verifique sua configuração`,
    no_workstations_found: 'Nenhuma Estação de Trabalho Encontrada',
    no_workstation_selected: 'Nenhuma Estação de Trabalho selecionada',
    are_you_sure_to_reset_daily_items: 'Tem certeza que quer redefinir os itens diários?',
    bring_an_item_to_antenna: 'Coloque um item próximo à antena',
    press_start_to_read: 'Pressione o botão Iniciar para \ncomeçar a ler produtos RFID',
    reading_in_progress: 'Leitura em andamento',
    waiting_for_product: 'Aguardando produto...',
    paste_comma_separeted_tags: 'Cole tags separadas por vírgula e pressione enter...',
    connection_workstation_progress: 'Conexão à estação de trabalho em andamento..',
    operation_success: 'Operação confirmada com sucesso',
    outbound_success: 'Expedição confirmada com sucesso',
    inbound_success: 'Recebimento confirmado com sucesso',
    pack_success: 'Embalagem confirmada com sucesso',
    transfer_to_zone_success: 'Transferência para Zona confirmada com sucesso',
    simple_item_list_success: 'Lista de Itens Simples confirmada com sucesso',
    list_empty: 'Lista está vazia',
    looks_like_anything_in_list: 'Parece que você não tem nada na sua lista',
    generic_success: '{{code}} confirmado com sucesso',
    generic_success_canceled: '{{code}} cancelado com sucesso',
    generic_error: '{{code}} erro',
    fill_all_fields_and_search_an_item_configuration: 'Preencha todos os campos e pesquise uma configuração de item',
    encoding_success: 'Codificação confirmada com sucesso',
    encoding_success_none: 'Item já associado anteriormente',
    read_some_identifier_to_start_verification: 'Leia algum identificador para iniciar a verificação',
    warning_items_found: 'Itens com aviso encontrados',
    are_you_sure_you_want_to_confirm: 'Tem certeza que quer confirmar?',
    item_session_list_confirm: 'Lista confirmada com sucesso',
    operation_in_progress: 'Operação em andamento, por favor, aguarde...',
    sorting_error_zones: 'Zona de origem não valorizada, impossível continuar com a ventilação',
    connection_in_progress: 'Conexão em andamento...',
    checklist_there_are: 'Existem',
    checklist_missings: 'itens ausentes',
    checklist_overqty: 'itens em excesso',
    checklist_unexpecteds: 'itens inesperados',
    checklist_confirm_mismatch_question: 'Tem certeza que quer confirmar mesmo assim?',
    force_update_content: 'Tem certeza que quer forçar o envio para SAP?',
    connection_to_station_in_progress: 'Conexão à estação em andamento',
    tag_killed: 'Tag excluída',
    tag_replaced: 'Tag substituída',
    tag_deleted: 'Tag excluída',
    write_tag: 'Tag escrita com sucesso',
    not_ready: 'Não pronto',
    readyf: 'Pronto',
    nfcDecryption: 'Descriptografia NFC. Por favor, mantenha a tag imóvel',
    parcel_success: 'Pacote confirmado com sucesso',
    sentry: {
      success: 'Obrigado pelo seu feedback! Sua contribuição nos ajuda a melhorar nosso serviço.'
    },
    confirm_force_shipment: 'Confirmar envio com PFAS',
    input_rfid_barcodes: 'Por favor, insira os códigos de barras RFID, separados por vírgula ou nova linha',
    //valentino
    are_you_sure_to_clear_reads: 'Tem certeza que quer limpar as leituras?',
    are_you_sure_to_confirm: 'Tem certeza que quer confirmar?',
    inbound_conveyor_confirm_missing_message:
      'Ainda existem -missing- itens por confirmar, tem certeza que quer confirmar?',
    ///
    newVersionAvailable: 'Nova versão disponível',
    pageWillReload: 'A página será recarregada automaticamente em 30 segundos',
    update_available_description:
      'Uma atualização está disponível para esta página. Recarregue a página para aplicar a atualização.',
    deviceManagerUpdateTitle: 'Atualização do Gerenciador de Dispositivos',
    deviceManagerUpdateDescription:
      'Uma nova atualização do Gerenciador de Dispositivos está disponível. Instale agora para garantir o desempenho ideal do leitor RFID.',
    deviceManagerUpdating:
      'O Gerenciador de Dispositivos está sendo atualizado. Por favor, aguarde, pode levar até 5 minutos.',
    deviceManagerUpdateCompleted: 'Atualização concluída com sucesso',
    deviceManagerUpdateCompletedAndRequiresReboot:
      'Atualização concluída com sucesso. Por favor, reinicie seu PC para aplicar as alterações.',
    exceeded_quantity_message:
      'A quantidade para a linha de ordem de produção foi atingida. Certifique-se de alterar a linha ou a ordem de produção.',
    empty_production_order: 'Não existem linhas na ordem de produção',
    empty_production_order_search: 'Nenhuma linha de ordem de produção corresponde à pesquisa realizada',
    areYouSureYouWantToDelete: 'Tem certeza que quer excluir?'
  },
  placeholder: {
    search_shipment_parcel: 'Pesquisar Envio ou Pacote',
    search_product_parcel: 'Pesquisar Produto ou Pacote'
  },
  confirm: {
    discrepancy_title: 'Pacote com discrepâncias',
    discrepancy_message: 'Foram encontrados produtos com discrepâncias. Tem certeza que quer confirmar o pacote?',
    confirm_delete_association: 'Tem certeza que quer excluir esta associação de item?',
    confirm_delete_operation_title: 'Excluir {{operation}}',
    confirm_delete_operation: 'Deseja excluir a operação? Todos os itens lidos serão perdidos.',
    confirm_delete_item_association: 'Tem certeza que quer excluir esta associação de item?',
    confirm_kill_tag: 'Tem certeza que quer excluir a tag {{type}} {{tag}}?',
    confirm_multiple_kill_tag: 'Tem certeza que quer excluir todas as tags?',
    confirm_disassociate_kill_tag: 'Tem certeza que quer desassociar e excluir a tag {{type}} {{tag}}?',
    confirm_disassociate_multiple_kill_tag: 'Tem certeza que quer desassociar e excluir todas as tags?',
    confirm_operation_title: 'Confirmar {{operation}}',
    confirm_operation_text: 'Deseja confirmar a operação?',
    confirm_operation_text_irreversible: 'Deseja confirmar a operação? Esta ação não pode ser revertida.',
    confirm_operation_text_partial_confirm: 'Enviando leitura para JDE. Tem certeza que quer continuar?',
    confirm_operation_text_partial_confirm_without_jde: 'Tem certeza que quer continuar?',
    post_confirm_action_title: 'Continuar',
    post_confirm_action_keep_input: 'Operação concluída. Realizar outra operação?',
    post_confirm_action_change_input: 'Operação concluída. Realizar outra operação?',
    confirm_close_asn_title: 'Confirmação de Fechamento',
    confirm_close_asn_text:
      'Alguns pacotes não foram recebidos. Tem certeza que quer FORÇAR o fechamento deste envio?',
    unpack: 'Pacote já embalado. Deseja proceder com o desembalamento e reembalamento?',
    last_parcel_confirmerd: 'Todos os pacotes do envio {{code}} confirmados. Fechar também o envio?'
  },
  labels: {
    draft: 'Rascunho',
    ready_to_send: 'Pronto para enviar',
    send_await: 'Pendente',
    outbound_error: 'Erro de expedição',
    sent: 'Enviado',
    in_inbound: 'Em recebimento',
    receive_await: 'Pendente',
    ready_to_receive: 'Para receber',
    inbound_error: 'Erro de recebimento',
    received: 'Recebido',
    in_transit: 'Em trânsito'
  },
  serverError: {
    WRONG_ITEM_SUPPLIER: 'Alguns artigos lidos não podem ser assumidos pelo fornecedor.',
    QUANTITY_MISMATCH_ERROR: 'As quantidades inseridas não correspondem às quantidades detectadas.',
    ZONE_MISMATCH_ERROR: 'A zona inserida não corresponde à zona detectada.'
  },
  error_messages: {
    password_required: 'O campo senha é obrigatório',
    invalid_password: 'Senha Inválida',
    missing_workstation_place: 'Local de estação de trabalho ausente',
    connection_in_progress_title: 'Desculpe, a conexão falhou',
    connection_in_progress_text: 'Por favor, tente novamente mais tarde'
  },
  report_tbox: {
    umg: 'Umg',
    ddt_number: 'N.º DDT',
    creation_date: 'Data',
    capi_mdc: 'Capi MDC',
    qt_totale: 'Qtd Total',
    qt_accettata: 'Qtd Aceita',
    qt_scartata: 'Qtd Rejeitada',
    supplier: 'Fornecedor',
    notes: 'Notas'
  },
  custom: {
    countTBoxParcel: 'Pacote',
    countTBoxDDT: 'DDT',
    BARCODE_READ: 'Código de Barras Lido',
    RFID_START_READING: 'Iniciar leitura',
    RFID_STOP_READING: 'Parar leitura',
    RESULT_EVENT: 'Evento de resultado',
    TRACE: 'Rastreamento',
    INFO: 'Info',
    WARNING: 'Aviso',
    ERROR: 'Erro',
    deleteSession: 'Excluir Pacote',
    deleteSessionMessage: 'Tem certeza que quer excluir o pacote?',
    deleteList: 'Excluir DDT',
    deleteListMessage: 'Tem certeza que quer excluir o DDT?',
    WAM: 'SKU',
    sap_warning: 'Aviso SAP',
    total_list: 'Lista total',
    total_parcel: 'Pacote total',
    order_number: 'Número de ordem',
    addon: 'Addon',
    componentType: 'Tipo de componente',
    //cucinelli
    barcode: 'Código de Barras BC',
    barcodeBCTrim: 'Código de barras BC trim',
    barcodeJDE: 'Código de barras JDE',
    barcodeROQ: 'Código de barras ROQ',
    barcodeROQTrim: 'Código de barras ROQ trim',
    class: 'Classe',
    department: 'Departamento',
    dimensionSystem: 'Classe personalizada',
    ean: 'EAN',
    eanIdPadre: 'EAN Pai',
    itemId: 'Id do Item',
    stagioneROQ: 'Temporada ROQ',
    subclass: 'Tipo de Modelo',
    subdepartment: 'Subdepartamento',
    variantType: 'Tipologia ',
    variantModel: 'Modelo de variante',
    cardCode: 'Código do cartão',
    label: 'Etiqueta',
    rfidEnabled: 'RFID ativo',
    stato: 'Status',
    ricondizionamentoFornitore: 'Fornecedor de recondicionamento',
    codiceShelf: 'Compartimento de Estoque',
    montante: 'Seção',
    ripiano: 'Prateleira',
    scaffale: 'Estante',
    ASSOCIATED: 'Associado',
    NOT_ASSOCIATED: 'Não associado',
    REPLACED_ASSOCIATION: 'Substituído',
    identifiers: 'Identificadores',
    force_parcel: 'Forçar pacote',
    force_parcel_message: 'Tem certeza que quer forçar este pacote?',
    pesa_collo: 'Peso do colarinho',
    peso_kg: 'Peso (kg)',
    wrong_packaging_code: 'Código de embalagem errado',
    packaging_confirmed_no_weight: 'Você está confirmando uma embalagem sem peso, quer continuar?',
    attention: 'Atenção',
    continue: 'Continuar',
    model: 'Modelo',
    sizeCode: 'Código de tamanho',
    sizeDescription: 'Descrição do tamanho',
    serial: 'Série',
    identifier: 'Série',
    product: 'Código de Barras BC',
    shift: 'Turno',
    destination: 'Destino',
    regDate: 'Data',
    listPosition: 'Posição na lista',
    list: 'Lista',
    customerName: 'Nome do Cliente',
    regTime: 'Hora',
    event: 'Evento',
    customer: 'Cliente',
    isCarryover: 'Carry-over',
    carryoverValue: 'Carry-over',
    madeIn: 'Fabricado em',
    collectionCode: 'Coleção',
    collectionDescription: 'Descrição da Coleção',
    collectionYear: 'Ano',
    fatherProductValue: 'Produto Pai',
    genderValue: 'Gênero',
    genderValueDescription: 'Descrição do Gênero',
    line: 'Linha de Marca',
    lineDescription: 'Descrição da Linha',
    marchioDescription: 'Descrição da Marca',
    marchioValue: 'Marca',
    merchandiseClassCode: 'Categoria',
    merchandiseClassDescription: 'Descrição da Categoria',
    merchandiseSubclassCode: 'Subcategoria',
    merchandiseSubclassDescription: 'Descrição da Subcategoria',
    modelPartColor: 'Cor da Parte do Modelo',
    modelPartColorSizeValue: 'Tamanho da Cor da Parte do Modelo',
    isPermanent: 'Permanente',
    permanentValue: 'Permanente',
    isSeasonal: 'Sazonal',
    seasonalValue: 'Sazonal',
    sleeveTypeValue: 'Tipo de Manga',
    origin_location_mandatory_field_error: 'O local de origem é obrigatório',
    transactionDate_mandatory_field_error: 'A data de transação é obrigatória',
    customerCode_mandatory_field_error: 'O código de cliente é obrigatório',
    tipology_field_error: 'A tipologia é obrigatória',
    warehouseUsa_relabeling_mandatory_fields_error: 'A reetiquetagem é obrigatória',
    //valentino
    sconosciuto: 'DESCONHECIDO',
    prodottoSconosciuto: 'Produto desconhecido',
    reads_ok: 'LEITURAS OK',
    tot_to_check: 'Total a verificar',
    //moncler
    confirm_force_received_text: 'Este envio já foi confirmado. Gostaria de removê-lo da lista?',
    confirm_force_received_sap_text:
      'O envio já foi recebido no SAP. Gostaria de removê-lo da lista?',
    confirm_force_received_partially_sap_text:
      'O envio já foi PARCIALMENTE recebido. Por favor, complete-o no SAP. Gostaria de removê-lo da lista?',
    //louis vuitton
    tooManyTags: 'Tags em excesso',
    nfcDetectedPleaseUseProductControl: 'Tag NFC detectada. Por favor, utilize a funcionalidade de Controle de Produto.',
    GENERIC_ERROR: 'Erro Genérico - Por favor, entre em contato com o suporte via ContactIS',
    ECERTIFICATE_WORKORDER_NOT_FOUND: 'Ordem de trabalho não encontrada no eCertificate',
    ITEM_IN_ANOTHER_PARCEL: 'Este item já está declarado em outro pacote',
    ECERTIFICATE_WORKORDER_CREATED_BOT_NOT_COMPLETED:
      'A ordem de trabalho foi criada no eCertificate mas não foi concluída',
    INVALID_TIMESTAMP: 'Timestamp inválido',
    INVALID_SERIAL: 'Número de série inválido',
    INVALID_WORKORDER: 'Número de ordem de trabalho inválido',
    INVALID_SKU: 'SKU inválido',
    INVALID_PARCEL_NUMBER: 'Número de pacote inválido',
    SAP_UCS_NOT_CONFIRMED: 'UCS *{parcelCode} não confirmado no final da linha de montagem',
    SAP_REMOVABLE_SYNCHRO_NOT_PERFORMED: 'Sincronização removível não realizada',
    SAP_INCORRECT_OPERATION_STATUS: 'Status de operação do UCS *{parcelCode} não está correto no SAP ME',
    SAP_COMPLETED_NOT_FOUND_IN_TNT: 'UCS já concluído no SAP, não presente no T&T',
    SAP_UCS_CANNOT_BE_COMPLETED: 'UCS *{parcelCode} não pode ser concluído no SAP ME/MII',
    SAP_WORKORDER_CLOSED: 'A ordem de trabalho associada ao UCS *{parcelCode} está encerrada no SAP MII',
    SAP_INTERNAL_ERROR: 'Erro técnico no SAP MII',
    SAP_TIMEOUT_BUT_OK_AGGREGATION: 'Timeout -> Agregação está OK',
    LVSP_PARCEL_NUMBER_ALREADY_AGGREGATED: 'Número de pacote já agregado no LVSP',
    LVSP_SERIAL_ALREADY_AGGREGATED: 'Número de série já agregado anteriormente no LVSP',
    LVSP_MISMATCH_EXPECTED_QUANTITY: 'Incompatibilidade entre quantidade lida e quantidade esperada no LVSP',
    LVSP_SKU_NOT_FOUND: 'SKU desconhecido no LVSP',
    LVSP_SUPPLIER_NOT_FOUND: 'Fornecedor desconhecido no LVSP',
    TECHNICAL_ERROR: 'Problema técnico - por favor, entre em contato com o suporte via ContactIS',
    ERROR_IN_PARCEL_ITEMS:
      'Ocorreu um erro ao confirmar o pacote. Por favor, esvazie o pacote usando o ícone de lixeira e leia todos os itens novamente',
    NFC_PRODUCT_NOT_ALLOWED: 'O SKU requer uma tag NFC. Por favor, utilize a funcionalidade de Controle de Produto.',
    product_is_authentic: 'Produto é autêntico',
    not_sellable: 'NÃO VENDÁVEL. Por favor, abra um ticket NeoContact (coloque no bucket WDF).',
    stock_product:
      'PRODUTO DE ESTOQUE: Manter produto como vendável. DEVOLUÇÃO DE CLIENTE: Ok para devolução ou troca, manter produto como vendável.',
    store_action: 'Ação de loja',
    reprint: 'Reimprimir',
    reprint_sent: 'Reimpressão enviada',
    row: 'Linha',
    longSKU: 'SKU Longo',
    pairingDate: 'Data de Produção',
    citesFlag: 'Cites',
    pairingSupplier: 'Fornecedor',
    batchNumber: 'Lote',
    status: 'Status',
    chrono: 'Chrono',
    logisticStatus: 'Status do Produto',
    serialNumber: 'Número de Série RFID',
    returnCode: 'Código de Devolução',
    viewCitesDocument: 'Ver Documento CITES',
    LV_LE_ERROR_ON_QUANTITY: 'A quantidade do pacote de Edição Limitada deve ser 1',
    LV_CUSTOM_DECODE_FAILED: 'Falha na decodificação da tag LV',
    // others
    reference: 'Referência',
    sender: 'Remetente',
    year: 'Ano',
    number: 'Número',
    TAG_STATUS_CONFIRMED: 'Já associado',
    halfpair: 'Meio Par'
  },
  imbustatrice: {
    and: ' e ',
    unkwon_tag: 'Tag Desconhecida',
    dynamic_tag: 'Tag {{role}}',
    dynamic_tag_missing: 'Tag {{role}} ausente',
    too_many_dynamic_tags: 'Tags {{role}} em excesso',
    dynamic_tag_already_associated: 'Tag {{role}} já associada',
    wrong_tag: 'Tag Errada',
    missing_tag: 'Tag ausente'
  },
  identifier_error: {
    ALREADY_ASSOCIATED_TAG: 'Já associada',
    WRONG_QC_STATUS: 'Status de controle de qualidade errado',
    WRONG_QC_SIZE: 'Tamanho de controle de qualidade errado',
    WRONG_QC_MODEL: 'Modelo de controle de qualidade errado',
    MISSING_MANDATORY_QC: 'Controle de qualidade obrigatório ausente',
    MISSING_PRODUCT_INFO: 'Informação do produto ausente',
    WRONG_TAG: 'Tag errada',
    UNKNOWN_TAG: 'Tag desconhecida',
    WRONG_PRODUCT: 'Produto errado',
    MISSING_MANDATORY_TAG: 'Tag obrigatória ausente',
    MISSING_OPTIONAL_TAG: 'Tag opcional ausente',
    EXTRA_TAG: 'Tag extra',
    TAG_MISMATCH: 'Incompatibilidade de tag',
    PRODUCTIONORDERROW_MISMATCH: 'Incompatibilidade de Associação de Linha de Ordem de Produção',
    MISSING_SYSTEM_TAG: 'Tag desconhecida',
    UNEXPECTED_TAG: 'Tag Inesperada',
    NOT_EXISTING_CERTILOGO_TAG: 'Código Certilogo não presente no sistema',
    KILLED_TAG: 'Tag excluída',
    MISSING_TAG: 'Tag ausente',
    TOOL_DETECTED: 'Tag de ferramenta detectada',
    TAG_NOT_PREENCODED: 'Tag não pré-codificada'
  },
  statuses: {
    RESTORE_VARIANT: 'RESTAURAR TIPOLOGIA',
    CONFIRM_ERROR: 'ERRO DE CONFIRMAÇÃO'
  },
  userSettings: {
    title: 'Configurações do usuário',
    autostopAntennaTimeout: 'Timeout de parada de antenas (ms)',
    autostartAntenna: 'Antena de partida automática',
    autoConfirmParcel: 'Confirmação automática de pacote',
    barcodeItemRead: 'Leitura de item por código de barras',
    antennas: 'Configurações de antenas',
    resetReadingsAfterOperation: 'Velocidade de reset após confirmação',
    slow: 'Lento',
    medium: 'Médio',
    fast: 'Rápido',
    printerCode: 'Código de impressora',
    enableOkSounds: 'Sons OK',
    enableKoSounds: 'Sons KO'
  },
  attributes: {
    material: 'Material',
    workerCode: 'Código do Trabalhador',
    workerExternalCode: 'Código Externo do Trabalhador',
    workerIdentifier: 'Identificador do Trabalhador',
    workerDescription: 'Descrição do Trabalhador',
    workerType: 'Tipo de Trabalhador',
    orderCode: 'Código de Ordem',
    sapQualityControlStatus: 'Status de Controle de Qualidade SAP',
    quantityOkWorker: 'QTD OK TRABALHADOR',
    quantityKoWorker: 'QTD KO TRABALHADOR',
    quantityOkRepair: 'QTD OK REPARO',
    quantityOkValdagno: 'QTD OK VALDAGNO',
    quantityOkFirstInbound: 'QTD OK PRIMEIRO RECEBIMENTO',
    quantityOkRis: 'QTD RISCO',
    quantityKoValdagno: 'QTD KO VALDAGNO',
    quantitySecondValdagno: 'QTD SEGUNDA ESCOLHA',
    quantityOkLining: 'QTD OK FORRO',
    quantityKoLining: 'QTD KO FORRO'
  },
  title: {
    report_problem: 'Reportar um problema',
    delete_shipment_title: 'Confirmação de Exclusão'
  },
  subtitle: {
    report_problem: 'Descreva o problema encontrado ou sugira uma melhoria',
    delete_shipment_message: 'Tem certeza que quer excluir este envio?'
  },
  label: {
    name: 'Nome',
    email: 'E-mail',
    description: 'Descrição do problema',
    close: 'Fechar',
    submit: 'Enviar feedback'
  },
  success: {
    message: 'Obrigado pelo seu feedback!'
  },
  button: {
    submit: 'Enviar',
    submitting: 'Enviando...'
  },
  pre_encoding: {
    correct: 'Corrigir',
    correction_title: 'Correção do cabedal',
    association_extra_right: 'Afaste o calçado direito do Pad e deixe apenas o esquerdo',
    association_extra_left: 'Afaste o calçado esquerdo do Pad e deixe apenas o direito',
    correction_instruction_right: 'Afaste o calçado direito do Pad e deixe apenas o esquerdo apoiado',
    correction_instruction_left: 'Afaste o calçado esquerdo do Pad e deixe apenas o direito apoiado',
    epc_reading: 'EPC: lendo....',
    epc_label: 'EPC: {{epc}}',
    write_correction: 'Escrever correção',
    correction_in_progress: 'Correção em andamento...',
    correction_write_success: 'Correção concluída com sucesso',
    correction_read_error: 'Ler apenas uma tag no Pad'
  }
}
